import React from 'react';
import { PREDEFINED_COLORS } from '../../localSeoStoreChart/LocalSeoStoreChart';
import './SearchCountBoxes.scss';

const SearchCountBox = ({ keyword, count, index, t }) => {
    return (
        <div 
            className="search-count-box" 
            style={{ '--line-color': PREDEFINED_COLORS[index] }}
        >
            <div className="keyword">{keyword}</div>
            <div className="count-container">
                <div className="count">{count}</div>
                <div className="searches-label">{t('searches')}</div>
            </div>
        </div>
    );
};

export const SearchCountBoxes = ({ searchCounts, t }) => {
    if (!searchCounts) return null;
    
    return (
        <div className="search-counts-container">
            {Object.entries(searchCounts).map(([keyword, count], index) => (
                <SearchCountBox 
                    key={keyword} 
                    keyword={keyword} 
                    count={count} 
                    index={index} 
                    t={t} 
                />
            ))}
        </div>
    );
};

export default SearchCountBoxes;